export var CustomResource;
(function(CustomResource) {
    CustomResource["Unfolded"] = "unfolded";
})(CustomResource || (CustomResource = {}));
export const unfoldedResourceEnabled = (plate)=>plate.$customBend !== null;

//# sourceMappingURL=resources.js.map